import React from 'react'
import { Pagination } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

const PaginateName = ({ pagesname, pagename }) => {
  return (
    pagesname > 1 && (
      <Pagination size='sm' className='my-2'>
        {[...Array(pagesname).keys()].map((x) => (
          <LinkContainer key={x + 1} to={`/pagename/${x + 1}`}>
            <Pagination.Item active={x + 1 === pagename}>
              {x + 1}
            </Pagination.Item>
          </LinkContainer>
        ))}
      </Pagination>
    )
  )
}

export default PaginateName
